import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const User = Loadable({
  loader: () => import("./User"),
  loading: Loading
})
